export const DEFAULT_COMPANY_TIMEZONE = 'Asia/Kolkata'

let activeTimezone = DEFAULT_COMPANY_TIMEZONE

export function getCompanyTimezone(): string {
  return activeTimezone
}

export function setCompanyTimezone(timezone: string): void {
  if (timezone) {
    activeTimezone = timezone
  }
}
